import { useContext, useEffect, useRef, useState } from "react";
import { WebrtcContext } from "../../modules/Webrtc";
import { CircularProgress, IconButton } from "@mui/material";
import PlayIcon from "@mui/icons-material/PlayArrow";

function VideoContainerStream({ idsw }: any) {
  const refVideo = useRef<HTMLVideoElement>(null);
  const { streamActive, setCurrentVideo, handlePlayStream, streamReadyToPlay } =
    useContext(WebrtcContext);
  const [isPlay, setPlay] = useState(false);

  const handlePlay = () => {
    const data = idsw && JSON.parse(atob(idsw));
    setPlay(true);
    setCurrentVideo(data);
    handlePlayStream(data.id, data.name);
  };

  useEffect(() => {
    if (!refVideo.current || !streamActive) return;
    refVideo.current.srcObject = streamActive.srcObject;
  }, [streamActive]);
  const play = !streamReadyToPlay ? (
    <CircularProgress size={50} />
  ) : (
    !isPlay && (
      <IconButton
        aria-label="play"
        color="primary"
        onClick={handlePlay}
        size="large"
        style={{
          borderBlockColor: "white",
          borderWidth: 2,
        }}
      >
        <PlayIcon
          style={{
            width: "25%",
            height: "25%",
            color: "white",
          }}
        />
      </IconButton>
    )
  );

  return (
    <div
      style={{
        width: "99vw",
        height: "99vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {isPlay && (
        <video
          id="player_stream"
          style={{ width: "100%", height: "100%" }}
          onError={() => console.log(" ERRROR VIDEO ")}
          onLoad={() => console.log(" ************************ load ")}
          autoPlay={true}
          ref={refVideo}
        />
      )}
      {play}
    </div>
  );
}

export default VideoContainerStream;
